import { useEffect, useState } from "react"
import MySettings, { IFaxNumber, IFaxNumbers } from "../../static/settings"
import React from "react"
import App from "../../App"
import Loading from "../../components/loading"
import { Button, Grid, IconButton, TextField } from "@material-ui/core"
import DeleteIcon from '@material-ui/icons/Delete';

interface IProps {
    customersId:string
}
const FaxNumbers = (props: IProps) => {
    const [sending,setSending] = React.useState(false)
    const [faxState,setFaxState] = React.useState<IFaxNumbers|undefined>(undefined)
    const [fromName,setFromName] = useState('')
    const [fromNumber,setFromNumber] = useState('')
    
    const getFaxNumbers = async () => {
        setFaxState(undefined)
        try{
            const settings=new MySettings()
            const faxNumbers=await settings.faxNumbers(props.customersId)
            if(faxNumbers.success){
                setFaxState(faxNumbers)
            }else{
                if(faxNumbers.message){
                    throw faxNumbers.message
                }else{
                    throw 'There was a problem fetching the fax numbers.'
                }
            }
        }catch(err){
            let message = 'Failed to load the fax numbers.'
            if(typeof err==='string'){
            message=err
            }
            App.newNotificationError(message)
        }
    }

    useEffect(()=>{
        getFaxNumbers()
    },[props.customersId])

    if(faxState===undefined){
        return <Loading />
    }

    const onAddNumberClicked = async () => {
        setFaxState(undefined)
        try{
            const settings=new MySettings()
            const faxNumbers = await settings.faxNumbersAdd(fromName,fromNumber,props.customersId)
            if(faxNumbers){
                if(faxNumbers.success){
                   setFaxState(faxNumbers)
                   App.newNotificationSuccess('Fax number added.')
                }else if(faxNumbers.message){
                    throw faxNumbers.message
                }                
            }else{
                throw 'There was a problem adding the fax number.'
            }
        }catch(err){
            let message = 'Failed to add the fax number.'
            if(typeof err==='string'){
                message=err
            }
            App.newNotificationError(message)
        }
    }

    const onDeleteNumberClicked = async (faxNumber:IFaxNumber) => {
        setFaxState(undefined)
        try{
            const settings=new MySettings()
            const faxNumbers = await settings.faxNumbersDelete(faxNumber.number,props.customersId)
            if(faxNumbers){
                if(faxNumbers.success){
                   setFaxState(faxNumbers)
                   App.newNotificationSuccess('Fax number removed.')
                }else if(faxNumbers.message){
                    throw faxNumbers.message
                }                
            }else{
                throw 'There was a problem removing the fax number.'
            }
        }catch(err){
            let message = 'Failed to remove the fax number.'
            if(typeof err==='string'){
                message=err
            }
            App.newNotificationError(message)
        }
    }

    return (<>
        <Grid container spacing={2}>
            <Grid item xs={3}>
                <TextField label="Name" value={fromName} onChange={(ev:any)=>{setFromName(ev.target.value)}}></TextField>
            </Grid>
            <Grid item xs={3}>
                <TextField label="Number" value={fromNumber} onChange={(ev:any)=>{setFromNumber(ev.target.value)}}></TextField>
            </Grid>
            <Grid item xs={3}>
                <Button variant="outlined" color="primary" onClick={onAddNumberClicked}>Add A Number</Button>
            </Grid>
        </Grid>
        {faxState.fromNumbers.map((faxNumber,index)=>{
            return (<div key={index}>{faxNumber.name} {faxNumber.number}
                        <IconButton title="Delete" color="primary" style={{ color: "red" }} onClick={()=>{
                            onDeleteNumberClicked(faxNumber)
                        }}>
                            <DeleteIcon />
                        </IconButton>
                    </div>)
        })}
    </>)
}
export default FaxNumbers